var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{class:{ 'paddingBtn': !_vm.isEdit },attrs:{"fluid":""}},[_c('TagHeader',{attrs:{"title":_vm.title,"buttons":_vm.buttons}}),(!_vm.isEdit)?_c('ProfileContent'):_vm._e(),(_vm.isEdit)?_c('AccountProfileContent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }